* {
  box-sizing: border-box;
}

:host {
  --card-min-height: 233px;
  display: block;
  max-width: 100%;
}

gz-textarea {
  --max-height-textarea: 116px;
}

:host([data-display-mode='edit']) {
  .discard-note-container,
  .delete-note-container {
    display: none;
  }
}

:host([data-display-mode='delete']) {
  .note-editor-container,
  .discard-note-container {
    display: none;
  }
}

:host([data-display-mode='discard']) {
  .note-editor-container,
  .delete-note-container {
    display: none;
  }
}

.wrapper {
  width: 100%;
  min-height: var(--card-min-height);
  padding: calc(var(--spacer) * 2);

  .note-editor-container {
    flex: 1;
  }

  .button-container {
    margin-top: calc(var(--spacer) * 3);
    display: flex;
    justify-content: space-between;
  }

  .title {
    text-align: start;
    padding-bottom: calc(var(--spacer) + 2px);
    color: var(--main-titles-inputs-600);
  }

  .discard-note-container,
  .delete-note-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;

    .discard-title,
    .delete-title {
      padding: var(--spacer) 0;
      color: var(--main-titles-inputs-600);
    }
  }
}
